module.exports = __webpack_public_path__ + "img/content_make17.dfbf14ef.png";